export default __webpack_public_path__ + "static/media/Moderat-Extended-Light.9d102c6e.ttf";